import Switch, {SwitchProps} from '@mui/material/Switch';

import {styled} from '@mui/material/styles';

export const CSwitch = styled(Switch)<SwitchProps>(
  (/* { theme } */) => ({
  }),
);
